<template>
  <list364 />
</template>


<script>
import List364 from "@/views/boards/single-page/364/List364.vue";

export default {
  components: {List364}
}
</script>

<style scoped></style>
